"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactImageMagnify = _interopRequireDefault(require("react-image-magnify"));
var _noop = _interopRequireDefault(require("lodash/noop"));
var _styles = require("./styles");
var _Hideable = _interopRequireDefault(require("../Hideable"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
// Prevents outside styles from messing up the images sizing
var enlargedImageStyle = {
  maxWidth: 'none'
};
var MainImage = function MainImage(_ref) {
  var src = _ref.src,
    srcSet = _ref.srcSet,
    sizes = _ref.sizes,
    magnifyOnHover = _ref.magnifyOnHover,
    isMobile = _ref.isMobile,
    largeSize = _ref.largeSize,
    enlargedImageSize = _ref.enlargedImageSize,
    caption = _ref.caption,
    onImageLoaded = _ref.onImageLoaded,
    onImageRequested = _ref.onImageRequested,
    isHidden = _ref.isHidden,
    hoverImageText = _ref.hoverImageText;
  var imageName = 'main';
  (0, _react.useEffect)(function () {
    onImageRequested(imageName);
  }, []);
  if (isMobile || !magnifyOnHover) {
    return /*#__PURE__*/_react["default"].createElement(_Hideable["default"], {
      isHidden: isHidden
    }, /*#__PURE__*/_react["default"].createElement("img", {
      src: src,
      srcSet: srcSet,
      sizes: sizes,
      alt: "",
      className: "pip-components__Visualizer--image-main",
      onLoad: onImageLoaded(imageName)
    }));
  }
  var magnifierProps = {
    // width/height for both of these needs to be given for the magnifier
    // to work correctly
    smallImage: {
      src: src,
      srcSet: srcSet,
      sizes: sizes,
      alt: '',
      isFluidWidth: true,
      onLoad: onImageLoaded(imageName)
    },
    largeImage: {
      src: src,
      alt: '',
      width: largeSize.width,
      height: largeSize.height,
      onLoad: onImageLoaded(imageName)
    },
    lensStyle: {
      backgroundImage: 'url(https://assets.homedepot-static.com/images/v1/zoom-screen-4X4.svg)'
    },
    shouldUsePositiveSpaceLens: true,
    imageClassName: 'pip-components__Visualizer--image-main',
    enlargedImageClassName: 'pip-components__Visualizer--image-zoomed',
    enlargedImageContainerClassName: 'pip-components__Visualizer--image-zoomed-container',
    enlargedImageContainerDimensions: {
      width: enlargedImageSize,
      height: enlargedImageSize
    }
  };
  return /*#__PURE__*/_react["default"].createElement(_Hideable["default"], {
    isHidden: isHidden
  }, /*#__PURE__*/_react["default"].createElement(_reactImageMagnify["default"], (0, _extends2["default"])({}, magnifierProps, {
    enlargedImageStyle: enlargedImageStyle
  })), /*#__PURE__*/_react["default"].createElement("p", null, hoverImageText), caption && /*#__PURE__*/_react["default"].createElement(_styles.Caption, null, caption));
};
MainImage.propTypes = {
  src: _propTypes["default"].string.isRequired,
  srcSet: _propTypes["default"].string,
  sizes: _propTypes["default"].string,
  magnifyOnHover: _propTypes["default"].bool.isRequired,
  isMobile: _propTypes["default"].bool.isRequired,
  largeSize: _propTypes["default"].shape({
    width: _propTypes["default"].number,
    height: _propTypes["default"].number
  }),
  enlargedImageSize: _propTypes["default"].string,
  caption: _propTypes["default"].string,
  onImageLoaded: _propTypes["default"].func,
  onImageRequested: _propTypes["default"].func,
  isHidden: _propTypes["default"].bool,
  hoverImageText: _propTypes["default"].string
};
MainImage.defaultProps = {
  srcSet: undefined,
  sizes: undefined,
  largeSize: {
    width: 1000,
    height: 1000
  },
  enlargedImageSize: '125%',
  caption: '',
  onImageLoaded: _noop["default"],
  onImageRequested: _noop["default"],
  isHidden: true,
  hoverImageText: 'Hover Image to Zoom'
};
var _default = /*#__PURE__*/(0, _react.memo)(MainImage);
exports["default"] = _default;
//# sourceMappingURL=_MainImage.js.map